import React, { FC } from 'react';
import NotificationActionWrapper from './NotificationActionWrapper';
import { getNotificationLabelFromDetails } from '../../utils/NotificationUtils';
import HyperLink from '../common/HyperLink';
import SeparatorWithText from '../common/SeperatorWithText';
import ManageAllNotificationPreference from './ManageAllNotificationPreference';

interface NotificationPreferenceSuccessCardProps {
	onChangePreference: () => void;
	notificationDetails: any;
}

const NotificationPreferenceSuccessCard: FC<NotificationPreferenceSuccessCardProps> = ({
	onChangePreference,
	notificationDetails,
}) => {
	return (
		<NotificationActionWrapper>
			<div className="h2medium">Notification preferences updated</div>
			<div className="h5regular">
				Your notifications preferences for{' '}
				<span className="font-semibold">
					{getNotificationLabelFromDetails(notificationDetails)}
				</span>{' '}
				has been updated.
			</div>
			<div className="bodyregular flex flex-row flex-nowrap gap-2">
				Made a mistake? Change your preferences{' '}
				<HyperLink text="here" onClick={onChangePreference} />
			</div>
			<SeparatorWithText className="mt-4" text="OR" />
			<ManageAllNotificationPreference />
		</NotificationActionWrapper>
	);
};

export default NotificationPreferenceSuccessCard;
